<ion-header translucent>
  <ion-toolbar color="subasta-header2">
    <ion-title>Adjudicaciones: {{subasta}}</ion-title> <!-- {{buqueActivoStr}} -->
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">Cerrar</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>

  <div class="example-container mat-elevation-z8">
    <table class="lista-pesadas" mat-table [dataSource]="dataSource" matSort> <!-- class="mat-elevation-z8" -->
      <ng-container matColumnDef="Subasta"> <!-- sticky -->
        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. Subasta </th>
        <td mat-cell *matCellDef="let element" > {{element.subasta}} </td>
        <td mat-footer-cell *matFooterCellDef>  </td>
      </ng-container>
  
      <!-- Name Column -->
      <ng-container matColumnDef="Lote">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Partida </th>
        <td mat-cell *matCellDef="let element"> {{element.part}} </td>
        <td mat-footer-cell *matFooterCellDef class="ion-text-end"> </td>
      </ng-container>
  
      <ng-container matColumnDef="Especie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Especie </th>
        <td mat-cell *matCellDef="let element"> {{element.especie}} </td>
        <td mat-footer-cell *matFooterCellDef class="ion-text-end"> </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="Precio">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header> Precio </th>
        <td mat-cell *matCellDef="let element" > {{formatPrecio(element.precio)}} €/{{element.unidad}}</td>
        <td mat-footer-cell *matFooterCellDef class="ion-text-center"> Total </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="Cantidad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cantidad</th>
        <td mat-cell *matCellDef="let element"> {{element.cantidad}}</td>
        <td mat-footer-cell *matFooterCellDef > {{getTotalesCantidad()}}</td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="Importe">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Importe </th>
        <td mat-cell *matCellDef="let element"> {{ formatImporte(element.precio, element.cantidad) }} €</td>
        <td mat-footer-cell *matFooterCellDef class="ion-text-left"> {{getTotalesImporte()}}€</td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  </div>
</ion-content>

